/* 🤖 this file was generated by svg-to-ts */
export const matIconGMobiledata: {
  name: 'g-mobiledata';
  data: string;
} = {
  name: 'g-mobiledata',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 11v2h2v2H9V9h7c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4z"/></svg>`
};
